"use client";

import React, { useState, useEffect } from "react";
import LoadingAnimation from "@/components/shared/LoadingAnimation";
import PageContainer from "@/components/shared/PageContainer";
import CommunitySubscriberWidget from "@/components/communities/CommunitySubscriberWidget";
import { Container } from "react-bootstrap";
import { useTenant } from "@/lib/providers/TenantProvider";

import { useRouter } from "next/navigation";

const CommunitySubscriberPage = props => {

  const router = useRouter();
  const { profile, community } = useTenant();
  const profileName =
    profile?.resourceName || profile?.name || props?.match?.params?.name;

  const [denied, setDenied] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    // Provider data is supplied by tenant-scoped layouts for these routes.
    if (community) {
      setDenied(!community.subscriberListEnabled);
      setLoaded(true);
    }
  }, [community]);

  return (
    <>
      {!loaded && (
        <div className="center-child-div-parent" style={{ margin: "2rem" }}>
          <LoadingAnimation />
        </div>
      )}
      {loaded && denied && router.replace("/403")}
      {loaded && (
        <PageContainer name={profileName} profile={profile} branded={true} onboarding={true}>
          <Container style={{ marginTop: "2rem" }}>
            <CommunitySubscriberWidget name={profileName} />
          </Container>
        </PageContainer>
      )}
    </>
  );
};
export default CommunitySubscriberPage;
